import * as process from 'process';
window['process'] = process;